import { useContext, type FC } from 'react';
import type { ModelVolatilitySurfaceProps } from './types';
import ModelVolatilitySurfaceContent from './model-volatility-surface-content';
import { Widget } from '../../widget';
import TokenSelector from '../../token-selector';
import { ModelVolatilitySurfaceContext } from '../../../../providers/model-volatility-surface-provider';
import Source from '../../source';
import WidgetButtons from '../../widget-buttons';

const ModelVolatilitySurfaceWidget: FC<ModelVolatilitySurfaceProps> = (props) => {
  const { widget, actions } = props;

  const { token, setToken, isFixedToken } = useContext(ModelVolatilitySurfaceContext);

  return (
    <Widget cardKey={widget.key}>
      <Widget.Header>
        <Widget.Title title={widget.title} />
        <Widget.HeaderPanel>
          <TokenSelector token={token} setToken={setToken} isFixedToken={isFixedToken} />
        </Widget.HeaderPanel>
        <Widget.Buttons>
          <WidgetButtons widget={widget} actions={actions} permissions={props.permissions} />
        </Widget.Buttons>
      </Widget.Header>
      <Widget.Content>
        <ModelVolatilitySurfaceContent {...props} />
      </Widget.Content>
      <Widget.Footer>
        <Source source="Deribit" url="https://www.deribit.com" />
      </Widget.Footer>
    </Widget>
  );
};

export default ModelVolatilitySurfaceWidget;
